import {I18nKey} from '@volkswagen-onehub/car-technical-details-schemas';
import React from 'react';
import {isI18nDebugEnabled} from './isI18nDebugEnabled';

export type TranslateFunction = (
  key: I18nKey,
  placeholders?: Record<string, string | undefined>
) => string;

export const I18nContext = React.createContext<TranslateFunction | undefined>(
  undefined
);

export function useTranslate(): TranslateFunction {
  const i18nContext = React.useContext(I18nContext);

  if (!i18nContext) {
    throw new Error('No i18n context was provided.');
  }

  return i18nContext;
}

export const translate =
  (i18n: Record<string, string | undefined>): TranslateFunction =>
  (key: I18nKey, placeholders?: Record<string, string | undefined>): string => {
    if (isI18nDebugEnabled()) {
      return key;
    }

    let translation = i18n[key];
    if (!translation) {
      return '';
    }

    for (const placeholderKey in placeholders) {
      const placeholderValue = placeholders[placeholderKey];

      translation = translation.replace(
        `{${placeholderKey}}`,
        placeholderValue ?? ``
      );
    }

    return translation;
  };
